import { Switch, useRouteMatch, Route } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { queryClient } from './config/queryClient';

import LeadBoard from './LeadBoard';
import AddLeadPage from 'modules/lead/AddLead/AddLeadPage';
import LeadDetails from 'modules/lead/LeadDetails/LeadDetails';
import OnlineLeadsList from 'modules/lead/LeadList/components/OnlineLeads/OnlineLeadsList';

function LeadRouterNew() {
  let { path } = useRouteMatch();
  return (
    <QueryClientProvider client={queryClient}>
      <Switch>
        <Route exact path={path} component={LeadBoard} />
        <Route exact path={`${path}/online`} component={OnlineLeadsList} />
        <Route exact path={`${path}/new/:id?`} component={AddLeadPage} />
        <Route path={`${path}/:id`} component={LeadDetails} />
      </Switch>
      {/* React Query DevTools - only in development */}
      {process.env.NODE_ENV === 'development' && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  );
}

export default LeadRouterNew;
